import { CheckCircle } from 'lucide-react';
import SquaresAvailableAtLine from '../game/SquaresAvailableAtLine';
import SquaresModalShell, {
  SquaresModalTitle,
  SquaresPrimaryButton,
  SquaresOutlineButton,
} from './SquaresModalShell';

export interface SeatReservedModalProps {
  /** Is the modal open */
  isOpen: boolean;
  /** Close handler */
  onClose: () => void;
  /** Reservation id returned by POST /pickems/:id/reserve, shown as "Confirmation: <uuid>" */
  reservationId: string | null;
  /** ISO timestamp for when the squares grid opens, or null */
  questionsPostedAt?: string | null;
  /** Navigate to My Games */
  onGoToMyGames: () => void;
  /** Navigate back to the lobby */
  onBackToLobby: () => void;
}

/**
 * "Seat Reserved" confirmation modal (DKPLAT-529) — shown after a successful reserve
 * POST, mirroring Pick'em's EntrySubmittedModal (DKPLAT-528).
 */
export default function SeatReservedModal({
  isOpen,
  onClose,
  reservationId,
  questionsPostedAt,
  onGoToMyGames,
  onBackToLobby,
}: SeatReservedModalProps) {
  return (
    <SquaresModalShell isOpen={isOpen} onClose={onClose} testId="seat-reserved-modal">
      <SquaresModalTitle>You're In!</SquaresModalTitle>

      <div className="flex justify-center">
        <CheckCircle className="w-14 h-14 text-[#53D337]" strokeWidth={1.5} />
      </div>

      <p
        className="text-zinc-200"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px', lineHeight: '20px' }}
      >
        Your seat is reserved. Don't forget to come back and pick your squares!
      </p>

      <SquaresAvailableAtLine
        questionsPostedAt={questionsPostedAt}
        testId="seat-reserved-available-at"
      />

      {reservationId && (
        <p
          data-test-id="seat-reserved-confirmation-id"
          className="text-white text-xs font-bold break-all"
        >
          Confirmation: {reservationId}
        </p>
      )}

      <div className="space-y-3">
        <SquaresPrimaryButton testId="seat-reserved-my-games-btn" onClick={onGoToMyGames}>
          GO TO MY GAMES
        </SquaresPrimaryButton>
        <SquaresOutlineButton testId="seat-reserved-back-to-lobby-btn" onClick={onBackToLobby}>
          BACK TO LOBBY
        </SquaresOutlineButton>
      </div>
    </SquaresModalShell>
  );
}
